export interface OutboundList {
  id: number;
  name: string;
  status: string;
  total_count: number;
  clean_count: number;
  blocked_count: number;
  uploaded_at: string | null;
  created_at: string;
}

export interface OutboundEntry {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  firm_name: string;
  location: string;
  practice_area: string;
  jd_year: number | null;
  dnc_result: string;
  dnc_reason: string;
  included_in_blast: boolean;
  override_reason: string;
  sent_at: string | null;
}

export function fmt(iso: string | null) {
  return iso ? new Date(iso).toLocaleDateString() : "—";
}

export function csrfToken(): string {
  return (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)?.content ?? "";
}

export const STATUS_LABELS: Record<string, string> = {
  uploaded:  "Uploaded",
  checking:  "Checking DNC...",
  checked:   "DNC Checked",
  blasting:  "Sending...",
  completed: "Completed",
  abandoned: "Not Proceeding",
};

export const STATUS_COLORS: Record<string, string> = {
  uploaded:  "bg-gray-100 text-gray-600",
  checking:  "bg-blue-100 text-blue-700",
  checked:   "bg-green-100 text-green-700",
  blasting:  "bg-purple-100 text-purple-700",
  completed: "bg-green-200 text-green-800",
  abandoned: "bg-gray-100 text-gray-400",
};
